import { Injectable } from '@angular/core';
import {  HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpClientRequestService {

  public tokenValue: String = null;
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa('Kcentra:B9384D01201BAED964')
    })
  };
  constructor(private _httpClient: HttpClient) { }
  Post(url: string, input: any): Observable<any> {
    return this._httpClient.post<any>(url, input, this.httpOptions);
  }
  Get(url: string): Observable<any[]> {
    return this._httpClient.get<any[]>(url, this.httpOptions);
  }
 
}
